var map = {
	"./dart.svg": "c7f1",
	"./elastic.svg": "0ffa",
	"./flutter.svg": "6b7b",
	"./graphql.svg": "7d60",
	"./hasura.svg": "1023",
	"./laravel.svg": "86a3",
	"./nest.svg": "b74f",
	"./next.svg": "47e9",
	"./postgres.svg": "6f9b",
	"./python.svg": "026c",
	"./pytorch.svg": "abdc",
	"./questdb.svg": "7722",
	"./react.svg": "a5a8",
	"./rust.svg": "326e",
	"./swift.svg": "64b9",
	"./tensor-flow.svg": "e9d6",
	"./ts.svg": "99fe",
	"./vue.svg": "ca1d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "998c";